import React from 'react'
// import Navbar from '../component/Navbar/Navbar'
// import Navbar2 from '../component/Navbar2'
import Footer from '../component/Footer/Footer'
import Naavbar from '../component/Navbar/Naavbar'

function Academy() {
  return (
    <div>
        <Naavbar/>
        {/* <Navbar2/> */}
    
{/* Responsive banner  */}
<div className="bg-[#02336c] py-20 px-4">
    <h1 className="text-white text-center font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
      ACADEMY
    </h1>
</div>  

{/* <end header */}

<main>
  <br/>
  <br/>
  <br/>
  <br/>
 <br/>
 <br/>
 <h3 style={{color:'#21005d'}}><b className='flex justify-center text-lg'>  COMING SOON</b></h3>
 <br/>
 <br/>
 <br/>
 <br/>
 <br/>
 <br/>
 <br/>
 <br/>
</main>
{/* <end main>
<footer> */}
<Footer/>
</div>
  )
}

export default Academy
